export const NavSearchIcon = ({ open }: { open: boolean }) => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.0999 17.0992C14.0764 17.0992 17.2999 13.8757 17.2999 9.89922C17.2999 5.92277 14.0764 2.69922 10.0999 2.69922C6.12345 2.69922 2.8999 5.92277 2.8999 9.89922C2.8999 13.8757 6.12345 17.0992 10.0999 17.0992Z"
        stroke={open ? 'rgb(255 255 255 / 30%)' : '#806E74'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.1001 18.8994L15.1851 14.9844"
        stroke={open ? 'rgb(255 255 255 / 30%)' : '#806E74'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
